<template>
  <v-chip
    v-if="type != null && typeObj != null"
    x-small
    label
    class="px-2 d-inline-flex align-center justify-center"
    :color="typeObj.color"
    :text-color="typeObj.textColor"
  >
    <v-icon class="mr-1" size="12">{{ typeObj.icon }}</v-icon>
    <span class="text-uppercase" style="font-weight: 700">{{
      typeObj.text
    }}</span>
  </v-chip>
</template>

<script>
import { CompanyType, CompanyTypeExpanded } from "@Share/config/enums";
import { $getKeyByValue } from "@Utils";

export default {
  name: "company-type",
  data() {
    return {
      CompanyTypeExpanded,
      typeObj: null,
    };
  },
  props: {
    type: {
      type: Number,
      default: null,
    },
  },
  methods: {
    updateTypeObj() {
      if (this.type != null)
        this.typeObj =
          this.CompanyTypeExpanded[$getKeyByValue(CompanyType, this.type)];
    },
  },
  watch: {
    type: {
      handler() {
        this.updateTypeObj();
      },
      immediate: true,
    },
  },
};
</script>
